import React from 'react';
// Import FontAwesome Component

function Introduction() {
    // Ce composant n'est affiché que lors du premier lancement du jeu
    return (
        <div className="road__Container">
            <p className="fade-in textAlign center">
                Vous êtes sur le point de vivre une aventure inoubliable, remplie de danger et de défis à chaque tournant.
                Dans ce jeu, vous serez plongé dans un monde fantastique, où vous devrez faire des
                choix difficiles pour avancer dans l'histoire.
            </p>
            <p className="fade-in textAlign center">
                Vous serez amené à rencontrer de nombreux personnages intéressants et à affronter de redoutables ennemis.
            </p>
            <p className="fade-in textAlign center">
                Vous devrez utiliser votre intelligence et votre bravoure pour surmonter les obstacles et atteindre vos objectifs.
                Le jeu est constamment mis à jour avec de nouvelles quêtes et de nouveaux défis, vous offrant ainsi une
                expérience de jeu en constante évolution.
            </p>
        </div>
    );
}

export default Introduction;